/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLineage = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M18.249 12.157a5 5 0 1 1-6.092 6.092l1.938-.498A3.002 3.002 0 0 0 20 17a3.002 3.002 0 0 0-2.249-2.905z" />
        <path d="M7 2a5 5 0 0 1 4.17 7.757L14 12.586V10h2v6h-6v-2l2.586.001-2.83-2.83A5 5 0 1 1 7 2zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
      </g>
    </g>
  </Icon>
);
export { SvgLineage as Lineage };
